import {
  IdTokenResult,
  onIdTokenChanged,
  signInWithEmailAndPassword as firebaseSignIn,
  signOut as firebaseSignOut,
  User,
} from "firebase/auth";
import { auth } from "./firebaseClient";
import { AUTH_SESSION_EVENT, isSelfHosted } from "../config/infra";
import {
  clearSelfHostedSession,
  createSelfHostedFirebaseUser,
  getSelfHostedUser,
  selfHostedLogin,
} from "./selfHostedAuth";

export const PLATFORM_PANEL_CLAIM = "platformPanelAccess";
export const PLATFORM_ROLES_CLAIM = "platformRoles";
export const PLATFORM_PANEL_ROLE = "god";

export interface PlatformAuthClaims extends IdTokenResult {
  claims: IdTokenResult["claims"] & {
    [PLATFORM_PANEL_CLAIM]?: boolean;
    [PLATFORM_ROLES_CLAIM]?: string[];
  };
}

export const signInWithEmailAndPassword = async (
  email: string,
  password: string,
) => {
  if (isSelfHosted) {
    const { user } = await selfHostedLogin(email, password);
    return {
      user: createSelfHostedFirebaseUser(user),
    };
  }
  return firebaseSignIn(auth, email, password);
};

export const signOut = async () => {
  if (isSelfHosted) {
    clearSelfHostedSession();
    return;
  }
  return firebaseSignOut(auth);
};

export const subscribeToAuthChanges = (handler: (user: User | null) => void) => {
  if (isSelfHosted) {
    const notify = () => {
      const stored = getSelfHostedUser();
      handler(stored ? createSelfHostedFirebaseUser(stored) : null);
    };
    notify();
    window.addEventListener(AUTH_SESSION_EVENT, notify);
    return () => window.removeEventListener(AUTH_SESSION_EVENT, notify);
  }
  return onIdTokenChanged(auth, handler);
};

export const getClaims = async (user: User): Promise<PlatformAuthClaims> => {
  if (isSelfHosted) {
    return user.getIdTokenResult(true) as Promise<PlatformAuthClaims>;
  }
  return user.getIdTokenResult(true) as Promise<PlatformAuthClaims>;
};
